import { render, staticRenderFns } from "./typeManage.vue?vue&type=template&id=3cac00da&scoped=true&"
import script from "./typeManage.vue?vue&type=script&lang=js&"
export * from "./typeManage.vue?vue&type=script&lang=js&"
import style0 from "./typeManage.vue?vue&type=style&index=0&id=3cac00da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac00da",
  null
  
)

export default component.exports